var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-modal", {
    attrs: {
      id: "video-modal",
      "hide-backdrop": "",
      "hide-header": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var hide = ref.hide
          return [
            _c(
              "div",
              {
                staticClass:
                  "rounded-10 overflow-hidden d-flex align-items-center justify-content-center w-100 h-100"
              },
              [
                _c("vue-plyr", { attrs: { options: _vm.options } }, [
                  _c("video", [
                    _c("source", {
                      attrs: { src: _vm.skolyStorage + _vm.subor }
                    })
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn --secondary --circle close-btn",
                on: {
                  click: function($event) {
                    return hide()
                  }
                }
              },
              [_c("span", { staticClass: "icon --close" })]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }